import { default as BaseIconButton } from '../IconButtonBase/IconButtonBase';
import { clsx } from 'clsx';
import { forwardRef, type JSX } from 'react';
import { buttonBaseVariants } from '../Button/styles';
import { iconButtonIconVariants, iconButtonVariants } from './styles';
import type { IconButtonProps } from './types';

export const ICONBUTTON_ID_CLASSNAME = 'ua-iconButton';

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref): JSX.Element => {
  const {
    variant,
    color,
    Icon,
    size = 'md',
    IconNode,
    className,
    iconClassName: iconClassNameProp,
    customStyle,
    loading,
    ...rest
  } = props;

  const { icon: iconCustomStyle } = customStyle ?? {};

  const iconButtonClassName = clsx(
    ICONBUTTON_ID_CLASSNAME,
    buttonBaseVariants({
      color,
      variant,
    }),
    iconButtonVariants({
      size,
    }),
    className,
  );

  const iconClassName = iconButtonIconVariants({
    className: iconClassNameProp,
    size,
  });

  return (
    <BaseIconButton
      loading={loading}
      ref={ref}
      {...rest}
      className={iconButtonClassName}
      data-color={color}
      data-size={size}
      data-variant={variant}
    >
      {Icon ? <Icon className={iconClassName} style={iconCustomStyle} /> : IconNode}
    </BaseIconButton>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
